const IconArrowUp = props => (
	<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M19.2947 15.2957C18.9054 15.685 18.2743 15.6852 17.8847 15.2962L12 9.42039L6.11522 15.2962C5.72562 15.6852 5.09452 15.685 4.70522 15.2957C4.31571 14.9062 4.31571 14.2746 4.70522 13.8851L11.2928 7.2975C11.6834 6.90698 12.3165 6.90698 12.7071 7.2975L19.2947 13.8851C19.6842 14.2746 19.6842 14.9062 19.2947 15.2957Z"
			fill="currentColor"
		/>
	</svg>
);

export default IconArrowUp;
